$(document).ready(function () {
  $('.tooltip_with_html').tooltip({
    tooltipClass: 'custom_tooltip_style',
    content: function () {
      return this.getAttribute("data_tooltipdata");
    },
    close: function( event, ui ) {
      $('.ui-helper-hidden-accessible').addClass("visually_hidden")
    },
  });
  let tag_course_id = "";

  if ($("#multi_user_report_errors").length > 0) {
      alert($("#multi_user_report_errors").val());
  }

  $('.modal-for-report-tag').click(function(event) {
    if (!!tag_course_id)
    {
      $.get('/reports/tag_modal.js?course_id=' + tag_course_id);
      $($(event.target).attr("data_link")).openModal();
    }
  });

  setTimeout(function(){
    $("div[id^='multi-user-detailed-progress-score-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='multi-user-list-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });

    $("div[id^='multi-user-photowall-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='multi-user-assignments-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='multi-user-list-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='multi-progress-summary-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
  },1000);

  $("input[id^='multi_progress_value_']").each(function(){
      showCircleChart("multi_progress_chart_"+$(this).attr('id').split('_')[3],parseInt($(this).val()),"Progress");
  });

  $("input[id^='multi_score_value_']").each(function(){
      showCircleChart("multi_score_chart_"+$(this).attr('id').split('_')[3],parseInt($(this).val()),"Score");
  });

  const MultiUserReport = {
    generateReport: function (data) {
      let user_role, user_status;

      const form = $('<form>', {
        action: '/reports/multi_user_report',
        method: 'POST'
      });
      if (!data.groups) {
        if(data.users.length == 0){
            alert("Please select users to generate report.");
            return;
        }
        $.each({
          courses: data.courses,
          users: data.users,
          template: data.template,
          pdf: data.pdf,
          authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
        }, function (key, val) {
          $('<input>').attr({
            type: "hidden",
            name: key,
            value: val
          }).appendTo(form);
        });
      } else {
        if (data.all_roles === true)
          user_role = "all";
        else
          user_role = "viewer";
        if (data.all_users === true)
          user_status = "all";
        else
          user_status = "activated";
        $.each({
          courses: data.courses,
          groups: data.groups,
          group_report_start_day: data.group_report_start_day,
          group_report_end_day: data.group_report_end_day,
          template: data.template,
          pdf: data.pdf,
          country_tags: data.country_tags,
          office_tags: data.office_tags,
          role_tags: data.role_tags,
          user_role: user_role,
          user_status: user_status,
          authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
        }, function (key, val) {
          $('<input>').attr({
            type: "hidden",
            name: key,
            value: val
          }).appendTo(form);
        });
      }
      form.appendTo('body').submit();
      form.remove();
    },
    downloadPhotoWallAsZip: function (data) {
      const form = $('<form>', {
        action: '/reports/multi_user_report',
        method: 'POST'
      });
      $.each({
        courses: data.courses,
        users: data.users,
        groups: data.groups,
        group_report_start_day: data.group_report_start_day,
        group_report_end_day: data.group_report_end_day,
        template: data.template,
        zip: true,
        country_tags: data.country_tags,
        office_tags: data.office_tags,
        role_tags: data.role_tags,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
      }, function (key, val) {
        $('<input>').attr({
          type: "hidden",
          name: key,
          value: val
        }).appendTo(form);
      });
      form.appendTo('body').submit();
      form.remove();
    },
    downloadExcelProgressAndScore: function (data) {
      const form = $('<form>', {
        action: '/reports/multi_user_report',
        method: 'POST'
      });
      $.each({
        courses: data.courses,
        users: data.users,
        groups: data.groups,
        group_report_start_day: data.group_report_start_day,
        group_report_end_day: data.group_report_end_day,
        template: data.template,
        excel: true,
        country_tags: data.country_tags,
        office_tags: data.office_tags,
        role_tags: data.role_tags,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
      }, function (key, val) {
        $('<input>').attr({
          type: "hidden",
          name: key,
          value: val
        }).appendTo(form);
      });
      form.appendTo('body').submit();
      form.remove();
    },

    downloadEssays: function (data) {
      const form = $('<form>', {
        action: '/reports/multi_user_report',
        method: 'POST'
      });
      $.each({
        courses: data.courses,
        users: data.users,
        groups: data.groups,
        group_report_start_day: data.group_report_start_day,
        group_report_end_day: data.group_report_end_day,
        template: data.template,
        pdf_essays_download: true,
        country_tags: data.country_tags,
        office_tags: data.office_tags,
        role_tags: data.role_tags,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
      }, function (key, val) {
        $('<input>').attr({
          type: "hidden",
          name: key,
          value: val
        }).appendTo(form);
      });
      form.appendTo('body').submit();
      form.remove();
    },
    
    downloadEssaysExcel: function (data) {
      const form = $('<form>', {
        action: '/reports/multi_user_report',
        method: 'POST'
      });
      $.each({
        courses: data.courses,
        users: data.users,
        groups: data.groups,
        group_report_start_day: data.group_report_start_day,
        group_report_end_day: data.group_report_end_day,
        template: data.template,
        excel_essays_download: true,
        country_tags: data.country_tags,
        office_tags: data.office_tags,
        role_tags: data.role_tags,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
      }, function (key, val) {
        $('<input>').attr({
          type: "hidden",
          name: key,
          value: val
        }).appendTo(form);
      });
      form.appendTo('body').submit();
      form.remove();
    },

    downloadExcelEvaluations: function (data) {
      const form = $('<form>', {
        action: '/reports/multi_user_report',
        method: 'POST'
      });
      $.each({
        courses: data.courses,
        users: data.users,
        groups: data.groups,
        group_report_start_day: data.group_report_start_day,
        group_report_end_day: data.group_report_end_day,
        template: "detailed",
        excel_evaluation: true,
        country_tags: data.country_tags,
        office_tags: data.office_tags,
        role_tags: data.role_tags,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
      }, function (key, val) {
        $('<input>').attr({
          type: "hidden",
          name: key,
          value: val
        }).appendTo(form);
      });
      form.appendTo('body').submit();
      form.remove();
    }
  };

  $("#report_user_start_day_hidden").change(function (event) {
    filter_users();
  });

  $("#report_user_end_day_hidden").change(function (event) {
    filter_users();
  });

  $("#users_all").click(function (event) {
    filter_users();
  });

  $("#users_activated").click(function (event) {
    filter_users();
  });

  $("#role_all").click(function (event) {
    filter_users();
  });

  $("#role_viewer").click(function (event) {
    filter_users();
  });

  $("#group_report_start_day_hidden").change(function (event) {
    filter_groups();
  });

  $("#group_report_end_day_hidden").change(function (event) {
    filter_groups();
  });
  
  $("#group_users_all").click(function (event) {
    filter_groups();
  });

  $("#group_users_activated").click(function (event) {
    filter_groups();
  });

  $("#group_role_all").click(function (event) {
    filter_groups();
  });

  $("#group_role_viewer").click(function (event) {
    filter_groups();
  });

  $("#group-or-user").change(function (e) {
    const selection = $(this).val();
    if (selection == "users") {
      $("#search-users-multi").show();
      $("#search-group-multi-reporting").hide();
      $(".user-selection-selected").show();
      $(".group-selection-selected").hide();
      filter_users();
    } else {
      $("#search-users-multi").hide();
      $("#search-group-multi-reporting").show();
      $(".user-selection-selected").hide();
      $(".group-selection-selected").show();
      filter_groups();
    }
    $('#report_country_tags').val("");
    $('#report_office_tags').val("");
    $('#report_role_tags').val("");
  });

  $("input[id^='multi_course_']").click(function (event) {
    const course_id = $(event.target).attr('value');
    $("#user-search-group-selection-container").hide();
    $("#users-selection-container").hide();
    $("#group_or_user_chosen").find(".chosen-search").css("display", "none");
    $("#group-or-user").val("users");
    $("#group-or-user").trigger("chosen:updated");
    const select_all = document.getElementById('select_all_user');
    select_all.checked = false;
    $("#multi_search").val("");
    $("#report_user_start_day_hidden").val("");
    $("#report_user_start_day").val("");
    $("#report_user_end_day_hidden").val("");
    $("#report_user_end_day").val("");
    const role_viewer = document.getElementById('role_viewer');
    role_viewer.checked = true;
    const users_activated = document.getElementById('users_activated');
    users_activated.checked = true;

    $('#report_country_tags').val("");
    $('#report_office_tags').val("");
    $('#report_role_tags').val("");
    $('#show-user-filter-tags').css("display", "none");
    $('#show-group-filter-tags').css("display", "none");
    $('#custom-report-step5').css("display", "none");
    tag_course_id = "";
    let course_ids = "";
    $("input[name='courses']:checked").each(function(index,item){
        if(index == $("input[name='courses']:checked").length - 1){
            course_ids = course_ids + $(item).val();
        } else {
            course_ids = course_ids + $(item).val() + ",";
        }
    });
    if (course_ids.length != 0 && course_ids.split(",").length == 1)
    {
      $.get('/reports/check_for_tags.js?course_id=' + course_ids.split(",")[0]).done(function (data) {
        if (!!data["id"])
        {
          tag_course_id = data["id"];
          $('#show-user-filter-tags').css("display", "block");
          $('#show-group-filter-tags').css("display", "block");
        }
      });
    }

    if ($("#group-or-user").length == 0)
    {
      $("#search-users-multi").hide();
      $("#search-group-multi-reporting").show();
      $(".user-selection-selected").hide();
      $(".group-selection-selected").show();
      filter_groups();
    }
    else
    {
      filter_users();
    }
  });

  $("#download_multi_user_photowall").click(function (e) {
    e.preventDefault();
    MultiUserReport.downloadPhotoWallAsZip({
      courses: $("input[name='selected_courses']").val(),
      users: $("input[name='selected_users']").val(),
      groups: $("input[name='selected_groups']").val(),
      group_report_start_day:$("input[name='generated_group_report_start_day']").val(),
      group_report_end_day:$("input[name='generated_group_report_end_day']").val(),
      template: "detailed",
      zip: true,
      country_tags: $('#report_country_tags').val(),
      office_tags: $('#report_office_tags').val(),
      role_tags: $('#report_role_tags').val()
    });
  });

  $("#download_multi_user_progress_and_score").click(function (e) {
    e.preventDefault();
    MultiUserReport.downloadExcelProgressAndScore({
      courses: $("input[name='selected_courses']").val(),
      users: $("input[name='selected_users']").val(),
      groups: $("input[name='selected_groups']").val(),
      group_report_start_day:$("input[name='generated_group_report_start_day']").val(),
      group_report_end_day:$("input[name='generated_group_report_end_day']").val(),
      template: "detailed",
      excel: true,
      country_tags: $('#report_country_tags').val(),
      office_tags: $('#report_office_tags').val(),
      role_tags: $('#report_role_tags').val()
    });
  });

  $("#download_multi_user_evaluations").click(function (e) {
    e.preventDefault();
    MultiUserReport.downloadExcelEvaluations({
      users: $("input[name='selected_users']").val(),
      courses: $("input[name='selected_courses']").val(),
      groups: $("input[name='selected_groups']").val(),
      group_report_start_day:$("input[name='generated_group_report_start_day']").val(),
      group_report_end_day:$("input[name='generated_group_report_end_day']").val(),
      template: "detailed",
      excel: true,
      country_tags: $('#report_country_tags').val(),
      office_tags: $('#report_office_tags').val(),
      role_tags: $('#report_role_tags').val()
    });
  });

  $("#multi_user_generate_report").click(function (e) {
    e.preventDefault();
    MultiUserReport.generateReport({
      users: $.map($("input[name='users[]']:checked"), function (element, index) {
        return parseInt($(element).val());
      }),
      courses: $.map($("input[name='courses']:checked"), function (element, index) {
        return parseInt($(element).val());
      }).join(","),
      groups: $.map($("input[name='groups']:checked"), function (element, index) {
        return parseInt($(element).val());
      }).join(","),
      group_report_start_day: $('#group_report_start_day').val(),
      group_report_end_day: $('#group_report_end_day').val(),
      template: "detailed",
      country_tags: $('#report_country_tags').val(),
      office_tags: $('#report_office_tags').val(),
      role_tags: $('#report_role_tags').val(),
      all_users: $('#group_users_all').is(":checked"),
      all_roles: $('#group_role_all').is(":checked")
    });
  });

  $("#multi_user_export_report_to_pdf").click(function (e) {
    e.preventDefault();
    MultiUserReport.generateReport({
      users: $.map($("input[name='users[]']:checked"), function (element, index) {
        return parseInt($(element).val());
      }),
      courses: $.map($("input[name='courses']:checked"), function (element, index) {
        return parseInt($(element).val());
      }),
      groups: $.map($("input[name='groups']:checked"), function (element, index) {
        return parseInt($(element).val());
      }).join(","),
      group_report_start_day: $('#group_report_start_day').val(),
      group_report_end_day: $('#group_report_end_day').val(),
      template: "detailed",
      pdf: true,
      country_tags: $('#report_country_tags').val(),
      office_tags: $('#report_office_tags').val(),
      role_tags: $('#report_role_tags').val(),
      all_users: $('#group_users_all').is(":checked"),
      all_roles: $('#group_role_all').is(":checked")
    });
  });

  $("#download_multi_user_essays").click(function(e){
      e.preventDefault();
      MultiUserReport.downloadEssays({
        courses: $("input[name='selected_courses']").val(),
        users: $("input[name='selected_users']").val(),
        groups: $("input[name='selected_groups']").val(),
        group_report_start_day:$("input[name='generated_group_report_start_day']").val(),
        group_report_end_day:$("input[name='generated_group_report_end_day']").val(),
        template: "detailed",
        country_tags: $('#report_country_tags').val(),
        office_tags: $('#report_office_tags').val(),
        role_tags: $('#report_role_tags').val()
      });
  });

  $("#download_multi_user_essays_excel").click(function(e){
      e.preventDefault();
      MultiUserReport.downloadEssaysExcel({
        courses: $("input[name='selected_courses']").val(),
        users: $("input[name='selected_users']").val(),
        groups: $("input[name='selected_groups']").val(),
        group_report_start_day:$("input[name='generated_group_report_start_day']").val(),
        group_report_end_day:$("input[name='generated_group_report_end_day']").val(),
        template: "detailed",
        country_tags: $('#report_country_tags').val(),
        office_tags: $('#report_office_tags').val(),
        role_tags: $('#report_role_tags').val()
      });
  });

  $("[data-report-users-search]").on("keyup", function(event) {
    if (!!document.searching_groups) {
      clearTimeout(document.searching_groups);
      delete document.searching_groups;
    }
    return document.searching_groups = setTimeout(function() {
      let attr, groups_element, text;
      text = $(event.target).val();
      attr = $(event.target).attr("data-report-users-search");
      groups_element = $(attr);
      if (!!text) {
        return $(groups_element).find("[data-user-name]").each(function() {
          const name = $(this).attr('data-user-name').toLowerCase();
          if (name.indexOf(text.toLowerCase()) !== -1) {
            return $(this).css("display", "block");
          } else {
            return $(this).css("display", "none");
          }
        });
      } else {
        return $(groups_element).find("[data-user-name]").css("display", "block");
      }
    }, 1000);
  });
});

window.filter_users = function()
{
  if (!!document.user_search)
    clearTimeout(document.user_search);
  delete document.user_search;
  document.user_search = setTimeout(function () {
    let user_status, user_role;

    let course_ids = "";
    $("input[name='courses']:checked").each(function(index,item){
        if(index == $("input[name='courses']:checked").length - 1){
            course_ids = course_ids + $(item).val();
        } else {
            course_ids = course_ids + $(item).val() + ",";
        }
    });
    $("#course-users").children(".user-details").remove();
    if ($('#step_4_courses').length == 1)
    {
      $('#step_4_courses').val(course_ids);
    }
    const select_all = document.getElementById('select_all_user');
    select_all.checked = false;
    if ($('#users_activated').prop("checked") == true)
    {
      user_status = "activated";
    }
    else
    {
      user_status = "all";
    }
    if ($('#role_viewer').prop("checked") == true)
    {
      user_role = "viewer";
    }
    else
    {
      user_role = "all";
    }

    const country_tags = $('#report_country_tags').val();
    const office_tags = $('#report_office_tags').val();
    const role_tags = $('#report_role_tags').val();

    $.get('/reports/course_users.json?courses=' + course_ids + '&search=' + $("#multi_search").val() + "&user_report_start_day=" + $("#report_user_start_day").val() + "&user_report_end_day=" + $("#report_user_end_day").val() + "&user_status=" + user_status + "&user_role=" +user_role + "&country_tags=" + country_tags + "&office_tags=" + office_tags + "&role_tags=" + role_tags).done(function (users) {
      if (!!users)
      {
        users.forEach(function (user, index) {
          $("#course-users").append(
                  "<div class='user-details' data-user-name='" + user.name + "'>\
                              <div class='smdc-radio left'>\
                                  <input id='multi_course_user_" + user.id + "' name='users[]' value='" + user.id + "' type='checkbox'>\
                                  <div class='check'></div>\
                                  <label for='multi_course_user_" + user.id + "'></label>\
                              </div>\
                              <div class='user-avatar'>\
                                  <div class='avatar-abbriviation purple-circle'>\
                                     <h5>" + user.initials + "</h5>\
                                  </div>\
                                  <ul>\
                                      <li><h5>" + user.name + "</h5></li>\
                                  </ul>\
                              </div>\
                          </div>"
                  );
        });
      }

      $("input[id^='multi_course_user_']").click(function () {
        if ($("input[name='users[]']").is(':checked')) {
          if ($("#custom-report-step3").length == 1)
          {
            $("#custom-report-step3").css("display", "none");
            $("#custom-report-step4").css("display", "none");
          }
          $(".generate-btns").children().css("opacity", "1");
          $(".generate-btns").children().css("pointer-events", "all");
        } else {
          if ($("#custom-report-step3").length == 1)
          {
            $("#custom-report-step3").css("display", "none");
            $("#custom-report-step4").css("display", "none");
          }
          $(".generate-btns").children().css("opacity", ".2");
          $(".generate-btns").children().css("pointer-events", "none");
        }
      });

      $("#user-search-group-selection-container").show();
      $("#users-selection-container").show();
      $(".generate-btns").children().css("opacity", ".2");
      $(".generate-btns").children().css("pointer-events", "none");
      $("#custom-report-step3").css("display", "none");
      $("#custom-report-step4").css("display", "none");
    }).fail(function(error){
      alert(error.responseJSON.message);
    });
  }, 1000);
}

window.filter_groups = function()
{
  let user_role, user_status;
  let course_ids = "";
  $("input[name='courses']:checked").each(function(index,item){
      if(index == $("input[name='courses']:checked").length - 1){
          course_ids = course_ids + $(item).val();
      } else {
          course_ids = course_ids + $(item).val() + ",";
      }
  });
  
  if ($('#group_users_activated').prop("checked") == true)
  {
    user_status = "activated";
  }
  else
  {
    user_status = "all";
  }
  if ($('#group_role_viewer').prop("checked") == true)
  {
    user_role = "viewer";
  }
  else
  {
    user_role = "all";
  }

  const country_tags = $('#report_country_tags').val();
  const office_tags = $('#report_office_tags').val();
  const role_tags = $('#report_role_tags').val();

  $.get('/reports/course_groups.json?courses=' + course_ids + "&group_report_start_day=" + $("#group_report_start_day").val() + "&group_report_end_day=" + $("#group_report_end_day").val() + "&user_status=" + user_status + "&user_role=" +user_role + "&country_tags=" + country_tags + "&office_tags=" + office_tags + "&role_tags=" + role_tags).done(function (groups) {
    $("#course-users").children(".user-details").remove();
    groups.forEach(function (group, index) {
      $("#course-users").append(
              "<div class='user-details' title='" + group.name + group.status +"' data-group-name='" + group.name + "'>\
                        <div class='smdc-radio left'>\
                            <input id='multi_course_group_" + group.id + "' name='groups' value='" + group.id + "' type='checkbox'>\
                            <div class='check'></div>\
                            <label for='multi_course_group_" + group.id + "'></label>\
                        </div>\
                        <div class='user-avatar'>\
                            <div class='avatar-abbriviation purple-circle'>\
                               <h5>" + group.abbreviation + "</h5>\
                            </div>\
                            <ul>\
                                <li><h5>" + group.name + " " + group.status + "</h5></li>\
                            </ul>\
                        </div>\
                    </div>"
              );
    });

    $("input[id^='multi_course_group_']").click(function () {
      if ($("input[name='groups']").is(':checked')) {
        $(".generate-btns").children().css("opacity", "1");
        $(".generate-btns").children().css("pointer-events", "all");
        $("#custom-report-step3").css("display", "none");
        $("#custom-report-step4").css("display", "none");
      } else {
        $(".generate-btns").children().css("opacity", ".2");
        $(".generate-btns").children().css("pointer-events", "none");
        $("#custom-report-step3").css("display", "none");
        $("#custom-report-step4").css("display", "none");
      }
    });

    $("#user-search-group-selection-container").show();
    $("#users-selection-container").show();
    $(".generate-btns").children().css("opacity", ".2");
    $(".generate-btns").children().css("pointer-events", "none");
    $("#custom-report-step3").css("display", "none");
    $("#custom-report-step4").css("display", "none");
  }).fail(function(error){
    alert(error.responseJSON.message);
  });;
}
